<template>
    <CompanyBoxContent :title="$t('company.yourInfo') + ':'">
        <template #data>
            <div class="company_tags">
                <!-- TOP -->
                <div class="box tags_box">
                    <div class="d-flex justify-content-between">
                        <div class="py-auto my-auto">
                            <span>{{ $t("company.tags") }}:</span>
                        </div>
                        <div class="d-flex align-self-center div_add_tag my-auto">
                            <button @click="toggleAddingNewTag"
                                class="btn btn_main btn_add_tag d-flex align-self-center my-auto">
                                <icon v-if="!addingNewTag" icon="Plus" class="icon_plus"></icon>
                                <icon v-if="addingNewTag" icon="Plus" class="icon_plus"
                                    style="transform: rotate(45deg);"></icon>
                            </button>
                        </div>
                    </div>
                    <!-- List of tags -->
                    <div class="d-flex mt-2">
                        <span v-if="!company.tags || company.tags.length == 0">
                            - {{ $t("company.noTag") }}
                        </span>
                        <template v-else>
                            <Tag v-for="(tag, index) in company.tags" :key="index" :color="tag.color" :bg="tag.bg_color"
                                :text="tag.name" :tagId="tag.id" :showDeleteButton="true" @delete="deleteTag(tag.id)"
                                class="w-100 me-2" />
                        </template>
                    </div>
                </div>
                <!-- Adding new tag -->
                <div v-if="addingNewTag" class="mt-2 box">
                    <div class="row">
                        <div v-for="(tag, index) in tags" :key="index" class="col-6">
                            <Tag @click="addToSelectedTags(tag.id)" :color="tag.color" :bg="tag.bg_color" :showDeleteButton="false"
                                :text="tag.name" :class="['w-100 mt-1', isSelected(tag.id) ? 'border-green' : '']" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-end mt-2">
                        <button @click="submitNewTag()" class="btn btn_main">{{ $t("utils.add") }}</button>
                    </div>
                </div>
                <div class="row mt-2 w-100 g-2 px-0">
                    <!-- Button for in contact with company -->
                    <div class="box py-2">
                        <div class="d-flex w-100 justify-content-between">
                            <div class="align-self-center">
                                <span v-if="!company.is_in_contact">{{ $t('company.imNotInContactWithCompany') }}</span>
                                <span v-if="company.is_in_contact">{{ $t('company.imInContactWithCompany') }}</span>
                            </div>
                            <div class="d-flex align-self-center">
                                <button v-if="!company.is_in_contact" @click="addInContact()"
                                    class="btn me-2 btn_contact_cancel  align-self-center justify-content-center">
                                    <icon icon="False"></icon>
                                </button>
                                <button v-if="company.is_in_contact" @click="deleteInContact()"
                                    class="btn btn_contact align-self-center justify-content-center">
                                    <icon icon="True"></icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- User avatar -->
                    <div class="box mt-3 in_contact_with">
                        <span>{{ $t('company.inOthersContactWith') }}:</span>
                        <div v-if="company.all_users_in_contact && company.all_users_in_contact.length > 0"
                            v-for="user in company.all_users_in_contact" :key="user.id" class="row">
                            <div class="d-flex mt-2">
                                <UserAvatar v-if="user" :user="user.institution_user.user"
                                    :user_role="user.institution_user.role" class="px-1 mt-1" />
                                <div class="row">
                                    <span style="font-weight: bold;">{{ user.institution_user.user.name }}</span>
                                    <span style="font-size: 14px;">{{ $t('general.from') }}: {{ user.started_contact
                                        }}</span>
                                </div>
                            </div>
                        </div>
                        <span v-else class="d-flex mt-1">
                            <span>- {{ $t('company.noOne') }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </CompanyBoxContent>
</template>

<script>
import Tag from '@/components/Tag.vue';
import CompanyBoxContent from "@/components/CompanyBoxContent.vue"
import UserAvatar from "@/components/CompanyDetail/UserAvatar.vue";
import VueMultiselect from 'vue-multiselect';

export default {
    components: {
        Tag,
        CompanyBoxContent,
        VueMultiselect,
        UserAvatar
    },
    props: {
        company: {
            type: Object,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            addingNewTag: false,
            selectedTags: []
        }
    },
    watch: {
        company: {
            deep: true,
            handler(newVal) {
                if (newVal.tags) {
                    this.selectedTags = [];
                }
            }
        }
    },
    methods: {
        toggleAddingNewTag() {
            this.addingNewTag = !this.addingNewTag;
        },
        isSelected(tagId) {
            return (
                this.company.tags.some(tag => tag.id === tagId) ||
                this.selectedTags.includes(tagId)
            );
        },
        addToSelectedTags(tagId) {
            if (!this.selectedTags.includes(tagId)) {
                this.selectedTags.push(tagId);
            } else {
                this.selectedTags = this.selectedTags.filter(id => id !== tagId);
            }
        },
        submitNewTag() {
            this.$store.getters.api.post(`/company/${this.$route.params.slug}/tag/add`, { tag_ids: this.selectedTags })
                .then(response => {
                    this.$emit('reload');
                    this.addingNewTag = false
                });
        },
        deleteTag(tagId) {
            this.$store.getters.api.delete(`/company/${this.$route.params.slug}/tag/${tagId}/delete`)
                .then(response => {
                    this.$emit('reload');
                });
        },
        addInContact() {
            this.$store.getters.api.post(`company/${this.$route.params.slug}/contact/add`)
                .then(function (response) {
                    this.$emit("reload");
                }.bind(this));
        },
        deleteInContact() {
            this.$store.getters.api.put(`company/${this.$route.params.slug}/contact/delete`)
                .then(function (response) {
                    this.$emit("reload");
                }.bind(this));
        },
        getLimitText(count) {
            return this.$t('multiselect.andMore', { count });
        },
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.info_box {
    height: 80px;
}

.btn_add_tag {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    svg {
        width: 30px;
        height: 30px;
        margin-left: 1px;
    }

    span {
        width: 30px;
        height: 30px;
    }
}

::v-deep .multiselect {
    .multiselect__option {
        font-size: 16px;
    }
}

.btn_contact {
    padding: 0;

    svg {
        width: 45px;
        height: 45px;
        stroke: $green;
        background-color: transparent;
    }
}

.btn_contact_cancel {
    padding: 0;

    svg {
        width: 45px;
        height: 45px;
        stroke: $red;
        background-color: transparent;
    }
}

.tags_box,
.in_contact_with {
    min-height: 100px;
    max-height: 200px;
    overflow-y: auto;
}

.border-green {
    border: 3px solid $green;
    border-radius: 10px;
    transition: border-color 0.3s ease;
}
</style>